export var BUTTON_BS_STYLES = ['default', 'primary', 'success', 'warning', 'danger', 'info', 'link'];